import React from "react";
import ReactDOM from "react-dom";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import "./cephalo.css";
import "./index.scss";

import { Provider } from "react-redux";

import { ConfigProvider } from "antd";
import configureStore from "./appRedux/store";
import { history } from "./appRedux/store/index";
import faIR from "antd/es/locale/fa_IR";
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <HistoryRouter history={history}>
      <ConfigProvider locale={faIR} direction="rtl">
        <App />
      </ConfigProvider>
    </HistoryRouter>
  </Provider>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
